<template>
  <div
    v-if="base_legal"
    :class="['base-legal-container', classe, { 'margin-bottom': cargaLiquida }]"
  >
    <label class="sem-margin">{{
      !!modificador ? "Base Legal" + modificador : "Base Legal"
    }}</label>
    <span v-html="baseReplace" />
    <!-- <span >{{ base_legal }}</span>    -->
  </div>
</template>

<script>
import stringFormatMixin from "@/mixins/stringFormatMixin";
export default {
  mixins: [stringFormatMixin],
  name: "BaseLegal",

  props: {
    modificador: String,
    base_legal: String,
    classe: String,
    cargaLiquida: Boolean
  },

  data() {
    return {};
  },

  computed: {
    baseReplace() {
      let target = this.strReplace(this.base_legal, "<a", "<a target='_blank'");
      let whitespace = this.strReplace(target, ";", ";&nbsp");
      return whitespace;
    }
  }
};
</script>

<style lang="scss" scoped>
.base-legal-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  label {
    font-weight: 600;
    font-size: 1rem;
  }

  span {
    font-weight: 600;
    text-align: right;
    word-break: break-all;
  }
}

.sem-margin {
  margin-bottom: 0;
}

.margin-bottom {
  margin-bottom: 0.7rem;
}
</style>
